<template>
	<component :is="icon" :class="iconClass" />
</template>

<script>
import { computed } from 'vue';
import { useLocaleData } from '@/locales/useLocaleData';

export default {
	props: ['icon'],
	setup() {
		const { localeData } = useLocaleData();
		const iconClass = computed(() => 'icon-' + localeData.value.direction);
		return {
			iconClass,
		};
	}
};
</script>

<style scoped>
.icon-rtl {
	transform: scaleX(-1);
}
</style>
